import { IOption } from '@r1-frontend/ui-react/components/select/select';

import { IAction } from '~/src/store';

import { EPaymentActions } from './index';

interface IPayloadData {
    paymentSum: number,
    email?: string | IOption<string>,
    isUseBonuses: boolean,
    bonusesValue: number,
    isSaveCard: boolean,
    agreement: string,
    agreementEnc: string,
}

export type TInitPaymentState = IAction<EPaymentActions.INIT_PAYMENT_STATE, IPayloadData>

const initializePaymentState = (state: IPayloadData): TInitPaymentState => ({
    type: EPaymentActions.INIT_PAYMENT_STATE,
    payload: state,
});

export default initializePaymentState;
